/**
 * Approvals event types for durable event recording (approvals:*).
 */
export enum ApprovalsEventType {
  APPROVAL_CREATED = 'approvals:created',
  /** Audit event for EVERY decide — carries the decider (APR-3). */
  APPROVAL_DECIDED = 'approvals:decided',
  APPROVAL_CANCELLED = 'approvals:cancelled',
  APPROVAL_EXPIRED = 'approvals:expired',
}

/**
 * Pub/sub channel for approvals events.
 */
export const APPROVALS_EVENTS_CHANNEL = 'approvals:events';